import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SharedModule } from "../../../shared/shared.module";
import { CreateInternalProviderComponent } from "./create-internal-provider/create-internal-provider.component";
import { InternalProviderComponent } from "./internal-provider.component";
import { ManageInternalProviderComponent } from "./manage-internal-provider/manage-internal-provider.component";

@NgModule({
  declarations: [CreateInternalProviderComponent, InternalProviderComponent, ManageInternalProviderComponent],
  imports: [CoreModule, SharedModule],
  exports: [CreateInternalProviderComponent, InternalProviderComponent, ManageInternalProviderComponent],
})
export class InternalProviderModule {}
